// extracted by mini-css-extract-plugin
module.exports = {"timeLabel":"_93444fe79c--timeLabel--_VT26","relative":"_93444fe79c--relative--IYgur","absolute":"_93444fe79c--absolute--yut0v"};